/**
 * Subtiele UI-geluiden (Web Audio). Respecteert prefers-reduced-motion.
 */

let audioCtx: AudioContext | null = null;

function getCtx(): AudioContext | null {
  if (typeof window === 'undefined') return null;
  if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return null;
  try {
    if (!audioCtx) audioCtx = new AudioContext();
    return audioCtx;
  } catch {
    return null;
  }
}

function playTone(freq: number, duration: number, gain: number, type: OscillatorType = 'sine') {
  const ctx = getCtx();
  if (!ctx) return;
  if (ctx.state === 'suspended') void ctx.resume();
  const osc = ctx.createOscillator();
  const g = ctx.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  g.gain.value = gain;
  osc.connect(g);
  g.connect(ctx.destination);
  const t = ctx.currentTime;
  g.gain.setValueAtTime(0, t);
  g.gain.linearRampToValueAtTime(gain, t + 0.01);
  g.gain.exponentialRampToValueAtTime(0.001, t + duration);
  osc.start(t);
  osc.stop(t + duration + 0.02);
}

/** Zachte tick bij tooltip / kleine interactie */
export function playUiTick() {
  playTone(880, 0.04, 0.04, 'sine');
}

/** Iets warmere toon — chat open / bericht */
export function playUiPop() {
  playTone(523, 0.07, 0.055, 'sine');
}

/** Korte glim — nieuw chatbericht */
export function playUiChime() {
  playTone(659, 0.05, 0.045, 'sine');
  setTimeout(() => playTone(880, 0.06, 0.035, 'sine'), 45);
}
